<template>
    <div class="order-list-wrap">
        <ul class="order-nav">
            <li v-for="(tabItem, i) in tab" :key="i" :class="active == i ? 'active' : ''" @click="getOrderList(i)">{{tabItem}}</li>
        </ul>
        <pull-refresh :refreshing="isRefreshing" :on-refresh="onRefresh">
            <van-list
                class="order-tab-con"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :offset="10"
                :immediate-check="false"
                v-if="orderList.length > 0"
            >
                <li class="order-tab-item" v-for="(item, index) in orderList" :key="index">
                    <!-- 订单编号，状态 -->
                    <div class="item-status-bar">
                        <span class="order-number">订单编号：{{item.orderNumber}}</span>
                        <span class="status-btn time-btn" v-if="item.status === 1">{{time(item.endTime)}}</span>
                        <span class="status-btn" v-else>{{item.statusText}}</span>
                    </div>
                    <div v-if="item.comInfoList.length > 0 && item.comInfoList[0].courierNumber" class="item-status-bar" style="display:block">
                        <div class="order-number">快递编号：</div>
                        <div class="order-number" v-for="(e,index) in item.comInfoList">
                            <div>{{ `(${e.comName}):${e.courierNumber}` }}</div>
                        </div>
                    </div>
                    <!-- 商品信息 -->
                    <div class="order-info-wrap">
                        <router-link :to="{path: '/order-detail', query: {id: item.orderNumber}}">
                            <!--商品为多条时-->
                            <div v-if="item.comInfoList.length > 1">
                                <div class="order-info">
                                    <!-- 商品图片 -->
                                    <div
                                        class="order-info-left dg-small-no-photo"
                                        v-for="(pic, index) in item.comInfoList"
                                        :key="index"
                                        v-if="index < 4"
                                    >
                                        <img :src="pic.comImage" alt v-if="pic.comImage " />
                                    </div>
                                    <div class="product-more" v-if="item.comInfoList.length >= 4">
                                        <van-icon name="weapp-nav"></van-icon>
                                    </div>
                                </div>
                            </div>
                            <!--商品为单条时-->
                            <div v-if="item.comInfoList.length === 1">
                                <div class="order-info">
                                    <!-- 商品图片 -->
                                    <div class="order-info-left dg-small-no-photo">
                                        <img :src="item.comInfoList[0].comImage" alt />
                                    </div>
                                    <!-- 商品名，价格 -->
                                    <div class="order-info-middle">
                                        <p class="order-info-text">
                                            <span class="group-tag">{{item.buyType === 2 ? '[团购]' : ''}}</span>
                                            {{item.comInfoList[0].comName}}
                                        </p>
                                        <div class="attr-box">
                                            <span
                                                class="attr-item"
                                                v-for="(attrItem, attrIndex) in item.comInfoList[0].attribute"
                                                :key="attrIndex"
                                            >{{attrItem.name + ':' + attrItem.value}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                        <!-- 合计栏 -->
                        <div class="amount-wrap">
                            <div>
                                共计
                                <span class="cred">{{item.orderCount || 0}}</span>件商品
                            </div>
                            <div class="amount">
                                {{item.status === 1 ? '需支付' : '实付款'}}：
                                <p class="amount-text">
                                    <span class="fs24">JPY</span>
                                    {{item.totalCost | setNumber}}
                                </p>
                            </div>
                            <div class="btnWrap" v-if="item.status === 1">
                                <button class="statusBtn" @click.stop="pay(index)">去支付</button>
                                <button class="statusBtn" @click.stop="removeOrder(item,index)">取消订单</button>
                            </div>
                            <div class="btnWrap" v-if="item.status === 6">
                                <button class="statusBtn1">已超时</button>
                                <button class="statusBtn" @click.stop="removeOrder(item,index)">删除订单</button>
                            </div>
                            <div class="btnWrap" v-if="item.status === 8">
                                <!-- <button class="statusBtn1" >已失败</button> -->
                                <button class="statusBtn" @click.stop="removeOrder(item,index)">删除订单</button>
                            </div>
                            <button class="statusBtn1" v-if="item.status === 2">待发货</button>
                            <button class="statusBtn1" v-if="item.status === 3">已发货</button>
                            <button class="statusBtn1" v-if="item.status === 4">已完成</button>
                        </div>
                    </div>
                </li>
            </van-list>
            <div v-if="flag" class="dg-no-order">暂无订单数据</div>
        </pull-refresh>
    </div>
</template>
<script >
import api from "@/server";
import pullRefresh from "@/components/pullRefresh.vue";
export default {
    data() {
        return {
            tab: ["全部", "待付款", "待发货", "已发货", "已完成"],
            active: this.$route.query.active,
            showPopup: true,
            params: {
                userId: this.$route.query.id,
                status: this.$route.query.active,
                pageSize: 10,
                pageNumber: 1
            },
            orderList: [],
            // 加载状态
            loading: false,
            // 数据是否加载完成状态
            finished: false,
            // 暂无数据状态
            flag: false,
            // 倒计时状态
            ticker: null,
            // 下拉刷新状态
            isRefreshing: false,
            // 删除订单传的数据
            removeOrderList: {
                orderList: []
            },
        };
    },
    components: {
        pullRefresh
    },
    activated() {
        this.getOrderList(this.$route.query.active);
    },
    deactivated() {
        this.flag = false;
        // this.params.pageNumber = 1;
    },
    methods: {
        getOrderList(index) {
            this.orderList = [];
            this.active = index;
            this.params.status = index;
            this.params.pageNumber = 1;
            this.finished = false;
            this.loading = false;
            this.flag = false;
            this.getListData();
        },
        // 请求数据
        getListData(type) {
            api
                .getOrderList(this.params)
                .then(res => {
                    // 防止进入页面出去后再进来计时器重复启动
                    if (this.ticker) {
                        clearInterval(this.ticker);
                    }
                    this.isRefreshing = false;
                    // 通过滚动加载的时候的处理
                    if (type === "scroll") {
                        if (res.data.commondityList.length > 0) {
                            this.orderList = this.orderList.concat(res.data.commondityList);
                            this.orderList = this.setStatus(this.orderList);
                            this.finished = false;
                        } else {
                            this.finished = true;
                        }
                        this.loading = false;
                        this.beginTimer(res.data.commondityList);
                    } else {
                        if (res.code === 200 && res.data.commondityList.length > 0) {
                            this.flag = false;
                            this.orderList = res.data.commondityList;
                            this.orderList = this.setStatus(this.orderList);
                            this.beginTimer();
                        } else {
                            this.orderList = [];
                            this.flag = true;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.flag = true;
                });
        },
        onLoad() {
            this.params.pageNumber++;
            this.getListData("scroll");
        },
        // 动态转换状态为文字
        setStatus(data) {
            data.map(item => {
                let statusText = "";
                switch (item.status) {
                    case 1:
                        statusText = "";
                        break;
                    case 2:
                        if (item.buyType === 2) {
                            if (item.groupOrder_doc[0].groupBuyPeople > item.groupOrder_doc[0].participateNum) {
                                statusText = "拼团中···";
                            } else {
                                statusText = "拼团成功···";
                            }
                        } else {
                            statusText = "等待发货···";
                        }
                        break;
                    case 3:
                        if (item.buyType === 2) {
                            statusText = "拼团成功···";
                        } else {
                            statusText = "";
                        }
                        break;
                    case 4:
                        statusText = "";
                        break;
                    case 6:
                        statusText = "订单过期";
                        break;
                    case 8:
                        statusText = "拼团失败"
                }
                return (item.statusText = statusText);
            });
            return data;
        },
        /*
          去支付
          @id: 支付订单id
          @totalCost: 支付总金额
        */
        pay(index) {
            if (this.orderList[index].join === 2) {
                if (this.orderList[index].groupOrder_doc[0].groupBuyEndTime > 0) {
                    this.$router.push({
                        name: "payment",
                        query: {
                            id: this.orderList[index].orderNumber,
                            totalCost: this.orderList[index].totalCost
                        }
                    });
                } else {
                    this.$toast.fail("拼团有效时间已结束");
                }
            } else {
                if (this.orderList[index].endTime > 0) {
                    this.$router.push({
                        name: "payment",
                        query: {
                            id: this.orderList[index].orderNumber,
                            totalCost: this.orderList[index].totalCost
                        }
                    });
                } else {
                    this.$toast.fail("订单已过期");
                }
            }
        },
        // 删除订单
        removeOrder(item, ind) {
            let mes = this.orderList[ind].status === 1 ? '取消' : '删除';
            this.$dialog.confirm({
                title: mes + "提示",
                message: "是否" + mes + "订单"
            }).then(() => {
                this.removeOrderList.orderList.push(this.orderList[ind].orderNumber);
                api.removeOrder(this.removeOrderList).then(res => {
                    if (res.code === 200) {
                        this.$toast.success(mes + "成功");
                        this.orderList.forEach((items, index) => {
                            if (items.orderNumber === item.orderNumber) {
                                this.orderList.splice(index, 1);
                            }
                        })
                        if (this.orderList.length === 0) {
                            this.flag = true;
                        }
                        this.removeOrderList.orderList = []
                    }
                })
            }).catch(() => {
                // this.removeOrderList.orderList = []
            })
        },
        // 计算倒计时的时间戳
        beginTimer() {
            this.ticker = setInterval(() => {
                for (let i = 0, len = this.orderList.length; i < len; i++) {
                    const item = this.orderList[i];
                    if (item.endTime > 0) {
                        item.endTime = item.endTime - 1000;
                    }
                }
            }, 1000);
        },
        // 每秒把时间重新计算下
        time(time) {
            // 这个函数是
            if (time >= 0) {
                let h = Math.floor(time / 1000 / 60 / 60);
                let m = Math.floor((time / 1000 / 60) % 60);
                let s = Math.floor((time / 1000) % 60);
                h = h < 10 ? "0" + h : h;
                m = m < 10 ? "0" + m : m;
                s = s < 10 ? "0" + s : s;
                return h + "时" + m + "分" + s + "秒";
            } else {
                return '已过期'
            }
        },
        // 下拉刷新
        onRefresh() {
            this.isRefreshing = true;
            this.params.pageNumber = 1;
            this.finished = false;
            this.loading = false;
            this.flag = false;
            this.getListData();
        },
        // 
        getCourierNumber(comInfoList) {
            let ret = ""
            comInfoList.forEach(e => {
                ret += `(${e.comName}):${e.courierNumber}`
            })
            console.log("--------", ret)
            return ret;
        }
    }
};
</script>
<style lang="scss" >
.order-list-wrap {
    .order-nav {
        width: 100%;
        max-width: 750px;
        height: 88px;
        background: white;
        border-bottom: 1px solid #ebedf0;
        position: fixed;
        top: 88px;
        display: flex;
        font-size: 28px;
        z-index: 999;
        .active {
            color: $fc07;
            &:after {
                background: #d5503f;
            }
        }
        li {
            flex: 1;
            text-align: center;
            line-height: 88px;
            color: #666;
            position: relative;
            &:after {
                content: "";
                width: 80px;
                height: 5px;
                position: absolute;
                bottom: 0;
                left: 50%;
                margin-left: -40px;
            }
        }
    }
    .pull-refresh {
        margin-top: 30px;
    }
    .order-tab-con {
        width: 100%;
        height: auto;
        padding: 0 30px 30px;
        // margin-top: 30px;
        box-sizing: border-box;
        .order-tab-item {
            width: 100%;
            padding: 20px 30px 50px;
            box-sizing: border-box;
            background: $bg02;
            border-radius: $br20;
            box-shadow: $box-shadow3;
            margin-bottom: 24px;
            /*订单状态，编号*/
            .item-status-bar {
                min-height: 70px;
                line-height: 70px;
                border-bottom: 2px solid $bc04;
                display: flex;
                justify-content: space-between;

                .order-number {
                    font-size: 28px;
                    color: $bc02;
                }
                .status-btn {
                    @include resetButton();
                    background: none;
                    font-size: 28px;
                    color: $fc04;
                }
                .time-btn {
                    font-size: 24px;
                }
            }
            /*商品信息，图片，名字，价格*/
            .order-info-wrap {
                .cred {
                    color: #d5503f;
                }
                .order-info {
                    display: flex;
                    margin: 16px 0;
                    align-items: center;
                    .product-more {
                        font-size: 46px;
                        color: $fc06;
                    }
                    .order-info-left {
                        width: 120px;
                        height: 130px;
                        border-radius: $br20;
                        overflow: hidden;
                        margin-right: 24px;
                        flex-shrink: 0;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    .order-info-middle {
                        flex: 1;
                        overflow: hidden;
                        height: 160px;
                        .attr-box {
                            width: 100%;
                            height: auto;
                        }
                        .group-tag {
                            color: $fc04;
                        }
                        .attr-item {
                            font-size: 22px;
                            color: $fc09;
                            background: $bg01;
                            padding: 6px 10px;
                            margin-right: 10px;
                            margin-bottom: 10px;
                            border-radius: 5px;
                        }
                        .order-info-text {
                            font-size: 28px;
                            color: $fc06;
                            margin: 10px auto 20px;
                            @include moreEllipsis(2);
                        }
                        .order-info-price {
                            font-size: 30px;
                            color: $fc04;
                        }
                    }
                    .order-info-right {
                        font-size: 32px;
                        color: $fc06;
                        flex-shrink: 0;
                    }
                }
                /*合计*/
                .amount-wrap {
                    width: 100%;
                    text-align: right;
                    font-size: 24px;
                    // height: 45px;
                    color: $fc06;
                    text-align: right;
                    // line-height: 48px;
                    margin-top: 25px;
                    display: inline-block;
                    p {
                        line-height: 45px;
                    }
                    div {
                        float: left;
                    }
                    button {
                        float: right;
                    }
                    .btnWrap {
                        float: right;
                        margin-top: 10px;
                    }
                    .amount {
                        margin-left: 15px;
                        margin-right: 20px;
                        display: flex;
                        .amount-text {
                            font-size: 26px;
                            color: $fc04;
                            line-height: inherit;
                        }
                    }
                    .statusBtn {
                        @include resetButton();
                        // width: 100px;
                        padding: 0 20px;
                        height: 45px;
                        background: $btn01;
                        color: $fc02;
                        border-radius: $br30;
                        font-size: 24px;
                        float: right;
                        line-height: 45px;
                        &:active {
                            background: $btnHover01;
                        }
                        &:nth-of-type(2) {
                            margin-right: 8px;
                        }
                    }
                    .statusBtn1 {
                        @include resetButton();
                        width: 130px;
                        height: 45px;
                        border: 1px solid $btn01;
                        color: $fc02;
                        border-radius: $br30;
                        font-size: 24px;
                        float: right;
                        line-height: 45px;
                        background: none;
                        color: $btn01;
                    }
                }
            }
        }
    }
}
</style>

